
import { BarLoader } from "react-spinners";
import { forgotPassword } from "../../services/backend_user_auth_service";

const initialValues = {
  email: "",
};

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Email is invalid").required("Email is required"),
  });


  const handleResetPassword = async (values) => {
    try {

      setLoading(true)
      const res = await forgotPassword(values.email)

      if (res) {
        setLoading(false)
        toast.success('Email send succesfully!', toastOptions)
        navigate('/')
      }

    } catch (error) {

      setLoading(false)
      toast.error(error.message, toastOptions)

    }

  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center min-vh-100 radial-gradient"
    >
      <Row className="justify-content-center w-100">
        <Col md={8} lg={6} xxl={3}>
          <Card className="mb-0">
            {loading && (
              <div className="mt-3">
                <BarLoader color="#007bff" width="100%" />
              </div>
            )}
            <Card.Body>
              <Link to="/" className="text-center d-block py-3 w-100">
                <h2>Aegis demo</h2>
              </Link>
              <p className="text-center">Forgot Password</p>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  handleResetPassword(values);
                }}
              >
                {({ errors }) => (
                  <Form>
                    <BootstrapForm.Group className="mb-3" controlId="email">
                      <BootstrapForm.Label>Email</BootstrapForm.Label>
                      <Field name="email">
                        {({ field }) => (
                          <BootstrapForm.Control
                            type="email"
                            isInvalid={!!errors.email}
                            {...field}
                          />
                        )}
                      </Field>
                      <BootstrapForm.Control.Feedback type="invalid">
                        {errors.email}
                      </BootstrapForm.Control.Feedback>
                    </BootstrapForm.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100 py-3 mb-4"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Reset Password"}
                    </Button>

                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
